import { useState } from "react";
import logo from "../assets/logo.png";
import headerBg from "../assets/cover.jpg";
import Overview from "./tracking/Overview";
import Logs from "./tracking/Logs";
import Stats from "./tracking/Stats";
import { useNavigate } from "react-router-dom";


export default function Tracking() {
  const [page, setPage] = useState("overview");
  const navigate = useNavigate();


  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div
        className="relative w-full h-20 flex items-center justify-between px-6 shadow-md"
        style={{
          backgroundImage: `url(${headerBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="relative z-10 flex items-center">
          <img src={logo} alt="SSD Logo" 
  onClick={() => navigate("/")} className="h-12 mr-3" />
        </div>
        <h1 className="absolute left-1/2 transform -translate-x-1/2 z-10 text-white font-bold text-3xl tracking-wide">
          Location Tracking System
        </h1>
      </div>

      {/* Tab Navigation */}
      <div className="flex space-x-6 mb-6 border-b px-6 pt-4">
        {[
          { key: "overview", label: "Overview" },
          { key: "logs", label: "Movement Log" },
          { key: "stats", label: "Statistics" },
        ].map((item) => (
          <button
            key={item.key}
            onClick={() => setPage(item.key)}
            className={`relative pb-2 text-sm font-medium transition-colors duration-200
              ${
                page === item.key
                  ? "text-blue-600 after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-0.5 after:w-full after:bg-blue-600"
                  : "text-gray-600 hover:text-blue-500"
              }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="px-6 pb-6">
        {page === "overview" && <Overview />}
        {page === "logs" && <Logs />}
        {page === "stats" && <Stats />}
      </div>
    </div>
  );
}
